export enum StoAffiliationType {
  FRANCHISED = 'FE',
  INTEGRATED = 'IN'
}

export enum StoreFormat {
  ECM = 'ECM',
  HYP = 'HYP',
  SPM = 'SPM',
  PRX = 'PRX'
}

export enum AppMode {
  REAL_TIME = 'REAL_TIME',
  TIME_SLOT = 'TIME_SLOT'
}

export enum Roles {
  SUPPORT = 'SUPPORT',
  VIP = 'VIP',
  DSI = 'DSI',
  COMEX = 'COMEX',
  DIR_FRANCE = 'DIR_FRANCE',
  DIR_FORMAT = 'DIR_FORMAT',
  DIR_BASSIN = 'DIR_BASSIN',
  DIR_REGION = 'DIR_REGION',
  DIR_MAGASIN = 'DIR_MAGASIN'
}
